import { createSlice } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

const initialState: TDefaultStoreDTO = {
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	...defaultMeta,
};

const dashboardPOAssetTypesTable = createSlice({
	name: 'dashboardPOAssetTypesTable',
	initialState,
	reducers: {
		...defaultStoreDTO,
		resetDashboardPOAssetTypesTable: () => initialState,
	},
});

export const {
	resetDashboardPOAssetTypesTable,
	setSort,
	setPage,
	setPageSize,
} = dashboardPOAssetTypesTable.actions;

export default dashboardPOAssetTypesTable.reducer;
